import styled from '@emotion/styled';

/**
 * Shared list reset used by both SidebarNav (top-level) and SidebarSection (nested).
 */
const SidebarList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export default SidebarList;
